import { defineStore } from 'pinia';
import IndicatorsIndexRepository from "@/Repositories/Indicators/IndicatorsIndexRepository";
import IndicatorsRepository from "@/Repositories/Indicators/IndicatorsRepository";
import _ from "lodash";
import {EventBus} from "@/event-bus";

export const IndicatorsStore = defineStore('IndicatorsStore', {
    state: () => ({

        currentIndicatorBook: {},
        indicators: {},
        indicatorBooks: {},
        indicatorToCustomize: {
            value: 0
        },

        // academicPeriods: [
        //     {id: 2022, title: "2021-2022"},
        //     {id: 2021, title: "2020-2021"},
        //     {id: 2020, title: "2019-2020"},
        // ],
        //
        // statuses: [
        //     {id: "IN_REVIEW", title: "In review"},
        //     {id: "GENERATED", title: "Generated"},
        // ],
        // editingStatuses: [
        //     {id: "with_value", title: "With value"},
        //     {id: "without_value", title: "Without value"},
        //     {id: "pending", title: "Pending"},
        //     {id: "edited", title: "Edited"},
        // ],
        // typology: [
        //     {id: "active", title: "Active"},
        //     {id: "inactive", title: "Inactive"},
        //     {id: "simple", title: "Simple"},
        //     {id: "with_details", title: "With details"},
        //     {id: "manual", title: "Manual"},
        //     {id: "generated", title: "Generated"},
        // ],
    }),

    actions: {

        /**>
         * @param indicatorBook
         */
        setCurrentIndicatorBook(indicatorBook) {
            this.currentIndicatorBook = indicatorBook;
        },

        /**>
         *
         * @param value
         */
        setIndicatorToCustomize(value) {
            this.indicatorToCustomize = value;
        },

        /**
         *
         * @param academicPeriods
         */
        setAcademicPeriods(academicPeriods) {
            this.academicPeriods = academicPeriods;
        },

        /**
         *
         * @param statuses
         */
        setStatuses(statuses) {
            this.statuses = statuses;
        },

        /**
         * Search data sources matching given criteria
         *
         * @param searchArguments
         * @returns {Promise<*>}
         */
        async searchDataSources(searchArguments) {
            return await IndicatorsIndexRepository.searchDataSources(searchArguments);
        },

        /**
         * Store a new Report
         *
         * @param Report
         * @returns {Promise<*>}
         */
        async storeIndicator(Report) {
            const newReport = await IndicatorsRepository.storeIndicator(Report);

            this.indicators = [newReport, ...this.indicators];

            EventBus.$emit('indicators.stored', _.cloneDeep(newReport))

            return newReport;
        },

        /**
         *
         * @param criteria
         * @returns {Promise<*>}
         */
        async searchIndicators(criteria) {
            return await IndicatorsRepository.searchIndicators(criteria);
        },

        /**
         *
         * @param indicator
         * @returns {Promise<*>}
         */
        async deleteIndicator(indicator) {
            return await IndicatorsRepository.deleteReport(indicator);
        },

        /**
         * @param indicatorBookId
         * @returns {Promise<*>}
         */
        async getIndicatorBook(indicatorBookId) {
            IndicatorsRepository.getIndicatorBook(indicatorBookId).then((response) => {
                this.indicators = response.data;
            }).catch(() => { return []});
        },

        /**
         * @returns {Promise<void>}
         */
        async getAllIndicatorBooks() {
            IndicatorsRepository.getAllIndicatorBooks().then((response) => {
                this.indicatorBooks = response.data;
            }).catch(() => { return []});
        },

        /**
         *
         * @returns {Promise<void>}
         */
        async customize(){
            IndicatorsRepository.customize(this.indicatorToCustomize).then((response) => {
                let finalYear = response.data.indicator.final_year;
                _.get(this.indicators, `main_groups.${response}`, false);
                this.indicators.main_groups[response.data.indicator.main_group_code].groups[response.data.indicator.group_code].data[response.data.indicator.indicator_type_code].total = response.data.indicator.total;
                this.indicators.main_groups[response.data.indicator.main_group_code].groups[response.data.indicator.group_code].data[response.data.indicator.indicator_type_code][finalYear] = response.data.indicator.total;
            }).catch(() => { });
        }
    },
})
